// extracted by mini-css-extract-plugin
export default {"errors":"FormErrors_errors__jWkmd"};